// extracted by mini-css-extract-plugin
module.exports = {"Container":"Footer_Container__NrKyv","Copyright":"Footer_Copyright__2C7-1"};